import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateTransactionActor, TransactionActor, TransactionActorListResponse, TransactionActorQueryParams } from '@frontend/transaction/types';

export class TransactionActorClient extends APIClient {
    public static readonly endpoint = '/transaction-api/v1';

    public static async fetchTransactionActors(queryParams?: ApiQueryParams<TransactionActorQueryParams>): Promise<TransactionActorListResponse> {
        return await this.apiPaginated<TransactionActorListResponse, TransactionActorQueryParams>(`${this.endpoint}/actors`, queryParams);
    }

    public static async postTransactionActor(
        accountId: string,
        transactionId: string,
        createTransactionActor: CreateTransactionActor
    ): Promise<TransactionActor> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/actors`, createTransactionActor);
        return await this.handleResponse<TransactionActor>(response);
    }

    public static async fetchTransactionActor(accountId: string, transactionId: string, actorId: string): Promise<TransactionActor> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/actors/${actorId}`);
        return await this.handleResponse<TransactionActor>(response);
    }

    public static async deleteTransactionActor(accountId: string, transactionId: string, actorId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/actors/${actorId}`);
        return await this.handleVoidResponse(response);
    }
}
